import { useEffect, useRef, useState } from "react";

import i18next from "i18next";
import { useNavigate, useSearchParams } from "react-router-dom";

import { useAuth } from "../../../context/auth";
import { supportGuestVerify } from "../../../protocols/rest/support";
import { supportErrorText } from "../utils";

import { ContainerComponent, DotsLoadingComponent } from "../../ui";
import SupportAccessForm from "../SupportAccessForm";

import { CardText, Loading, NarrowCard, PageWrapper } from "../style";

/**
 * /support/access?order=...&code=... — ссылка из письма гостю.
 * Есть и заказ, и код — сразу verify и к заявкам; только заказ — форма доступа с предзаполненным номером.
 */
const SupportAccessVerify = () => {
  const { t } = i18next;
  const navigate = useNavigate();
  const { isAuth } = useAuth();
  const [searchParams] = useSearchParams();

  const order = searchParams.get("order") || searchParams.get("order_id") || "";
  const code = searchParams.get("code") || "";

  const [isVerifying, setIsVerifying] = useState(!isAuth && !!order && !!code);
  const [error, setError] = useState(null);
  const startedRef = useRef(false);

  useEffect(() => {
    // залогиненный клиент видит заявки своего аккаунта
    if (isAuth) {
      navigate("/support", { replace: true });
      return;
    }

    if (!order || !code || startedRef.current) return;

    startedRef.current = true;

    supportGuestVerify({ order_id: order, code })
      .then(() => navigate("/support", { replace: true }))
      .catch(verifyError => {
        setError(supportErrorText(verifyError));
        setIsVerifying(false);
      });
  }, [isAuth, order, code, navigate]);

  if (isAuth) return null;

  return (
    <PageWrapper>
      <ContainerComponent>
        {isVerifying ? (
          <NarrowCard>
            <Loading>
              <DotsLoadingComponent />
            </Loading>
            <CardText style={{ textAlign: "center" }}>{t("support_verifying")}</CardText>
          </NarrowCard>
        ) : (
          <SupportAccessForm
            presetOrderId={order}
            initialError={error}
            onVerified={() => navigate("/support", { replace: true })}
          />
        )}
      </ContainerComponent>
    </PageWrapper>
  );
};

export default SupportAccessVerify;
